import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class MailerDomainService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private mailerDomainUrl = this.baseApiUrl + '/api/v1/mailer-domain';

  getMailerDomains(params: any = {}) {
    return this.http.get(`${this.mailerDomainUrl}`, {params});
  }

  getMailerDomain(id: string) {
    return this.http.get(`${this.mailerDomainUrl}/${id}`);
  }

  deleteMailerDomain(id: string) {
    return this.http.delete(`${this.mailerDomainUrl}/${encodeURIComponent(id)}`);
  }

  updateMailerDomain(id: string, domain: any) {
    return this.http.put(`${this.mailerDomainUrl}/${encodeURIComponent(id)}`, domain);
  }

  addMailerDomain(domain: any) {
    return this.http.post(`${this.mailerDomainUrl}`, domain);
  }

  getAllowedForProject(projectId: number) {
    return this.http.get(`${this.mailerDomainUrl}/project/${projectId}`);
  }
}
